import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  getSalesSegment,
  getSalesSegmentAsSelect,
} from '~/services/SalesSegment';
import { SalesSegment } from '~/types/SalesSegment';
import { SelectItem } from '~/types';

export function useSalesSegment(
  options: UseQueryOptions<SalesSegment[], unknown> = {},
): UseQueryResult<SalesSegment[], unknown> {
  return useQuery<SalesSegment[], unknown>(
    ['salesSegments'],
    () => getSalesSegment(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useSalesSegmentAsSelect(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[], unknown> {
  return useQuery<SelectItem[], unknown>(
    ['salesSegmentsAsSelect'],
    () => getSalesSegmentAsSelect(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
